import { Tooltip } from 'antd';
import React, { useState } from 'react';
import QRCode from 'react-qr-code';
import { RenderHTML } from '../../RenderHtml';
import Barcode from 'react-barcode';

const AvaiableGift = {
  Info: ({ intro }) => {
    return <RenderHTML string={`${intro}`} />;
  },
  QR: ({ qrid }) => {
    const [code, setCode] = useState('QR'); //BAR
    return (
      // <div className='absolute right-10 top-[3.5rem] z-[1000]'>
      <div className='w-fit'>
        <div className='mb-[10px] flex justify-between'>
          <div
            className={`h-[30px] w-[60px] cursor-pointer content-center rounded-md border border-solid text-center ${
              code === 'QR' ? 'border-[#0590f0] bg-[#e0f2ff]' : 'border-[#ecedf0]'
            }`}
            onClick={() => setCode('QR')}
          >
            QRCode
          </div>
          <div
            className={`h-[30px] w-[60px] cursor-pointer content-center rounded-md border border-solid text-center border-[#ecedf0]${
              code === 'BAR' ? 'border-[#0590f0] bg-[#e0f2ff]' : 'border-[#ecedf0]'
            }`}
            onClick={() => setCode('BAR')}
          >
            BarCode
          </div>
        </div>
        {code === 'BAR' ? (
          <Barcode value={qrid} format='CODE128' height={50} width={1} fontSize={13} />
        ) : (
          <div className=' flex w-[132px] flex-col justify-center rounded-lg bg-white p-4 py-2 text-12px drop-shadow-lg'>
            <QRCode
              style={{
                marginBottom: '4px',
              }}
              value={qrid}
              size={100}
            />
            <p className='line-clamp-1 text-center text-[#7B7B7B]'>QR code:</p>
            <Tooltip placement='bottom' title={<p className='text-black'>{qrid}</p>} color='#fff'>
              <p className='line-clamp-1 w-full text-center'>{qrid}</p>
            </Tooltip>
          </div>
        )}
      </div>
    );
  },
};

export default AvaiableGift;
